import { type LinkProps } from '@tanstack/react-router'

export const DASHBOARD_TABS: { label: string; value: string; to: LinkProps['to'] }[] = [
  {
    label: 'Task Management',
    value: 'task-management',
    to: '/dashboard/task-management',
  },
  {
    label: 'Case Updates',
    value: 'case-updates',
    to: '/dashboard/case-updates',
  },
  {
    label: 'Case Analysis',
    value: 'case-analysis',
    to: '/dashboard/case-analysis',
  },
  {
    label: 'General Info',
    value: 'general-info',
    to: '/dashboard/general-info',
  },
]
